import { defineNuxtRouteMiddleware } from 'nuxt/app';
import { type RouteLocationNormalized } from 'vue-router';

import { useAppStore } from '@/stores/app.store';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
  const groupId = to.params.groupId as string;
  const appStore = useAppStore();

  const { setHasWaitingInvite } = appStore;

  setHasWaitingInvite(groupId);
});
